module.exports = __webpack_public_path__ + "img/tab12.a346ef47.jpg";